import React, { Component } from "react";
import {
  Icon,
  Row,
  Col,
  Modal,
  Select,
  Button,
  Spin,
  DatePicker,
  Input,
  Checkbox,
  message,
  Radio,
} from "antd";
import axios from "axios";
import moment from "moment";
import { Translate } from "react-translated";
import F from "../../../Functions";
import DataHandler from "../../../utils/DataHandler";
import { SUB_TYPE_OF_CALL, TYPE_OF_CALL, get_label_from_value } from "../../../utils/Constants";
import Cookies from "js-cookie"

const { TextArea } = Input;
const Option = Select.Option;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const { confirm } = Modal;

class DashModal extends Component {
  state = {
    loading: false,
    action: null,
    agent: null,
    onBoarding_agent: null,
    notes: "",
    expiration_date: moment(new Date()).add(15, "days"),
    isAdditionalActions: false,
    Checkbox_array: ["Thank you"],
  };

  setVirtualOnBoardersDefault = () => {

    var val = "Virtual Onboarder";

    const agencyData = DataHandler.getTempHoldAgencyData();

    if (this.props.wizard.agency && this.props.wizard.agency.vonboard !== null && this.props.wizard.agency.vonboard === 0 || (agencyData && agencyData.vonboard !== null && agencyData.vonboard) === 0) {
      val = 'Send For Follow Up'
    }
    let action = 2;

    // F.log("vallllllllllllllllll", val);
    if (val === "Send For Follow Up") action = 1;
    if (val === "Virtual Onboarder") action = 2;

    for (let i = 0; i < this.props.financial_users.length; i++) {
      if (
        this.props.financial_users[i].id === val &&
        this.props.financial_users[i].user_type === "EFS"
      ) {
        action = 1;
        break;
      }
    }

    this.setState({
      agent: val,
      onBoarding_agent: val,
      action,
    });
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.financial_users !== prevProps.financial_users ||
      this.props.onboarding_users !== prevProps.onboarding_users
    ) {
      this.setVirtualOnBoardersDefault();
    }
  }

  // messageCheck() {
  //   F.log("checkBox array", this.state.Checkbox_array);
  //   let Checkbox_array = [...this.state.Checkbox_array];
  //   this.setState({ Checkbox_array: [...this.state.Checkbox_array] });
  //   F.log("Checkbox_array", Checkbox_array);
  //   // this.setState({
  //   //   Checkbox_array: [
  //   //     ...this.state.Checkbox_array,
  //   //     "Life",
  //   //   ],
  //   // });
  // }
  onChange(e) {
    // F.log(e.target);
  }
  onChangeBox = (e, i) => {
    // let checkBoxCurrentState = this.state.Checkbox_array;
    // let
    // checkBoxCurrentState[i] = !checkBoxCurrentState[i];
    // this.setState({
    //   Checkbox_array: checkBoxCurrentState
    // });
    // if (this.state.Checkbox_array) {
    // }
  };
  // unChecked = e => {
  //   let resetArray = new Array(data.length).fill(false);
  //   this.setState({
  //     Checkbox_array: resetArray
  //   });
  // };

  messageCheck = (value) => {
    // F.log("this.state.Checkbox_array", this.state.Checkbox_array);
    const arr1 = [...this.state.Checkbox_array];  // NOSONAR
    if (!arr1.includes(value)) {
      arr1.push(value);
    } else {
      // arr1=arr1.filter((e) => e !== value);
      const filteredArr = arr1.filter((e) => e !== value);
      this.setState({ Checkbox_array: filteredArr });
      return;
    }
    // F.log("arr1", arr1);

    this.setState({ Checkbox_array: arr1 });
  };

  //validate before sending the data
  validateSendData = () => {
    const { notes, agent, expiration_date } = this.state;
    let has_error = false;

    // Check if notes are empty
    if (notes.trim().length === 0) {
      message.error(F.translate(`Note is required.`));
      has_error = true;
    }

    // Check if agent is missing for action 1 or 2
    if (
      (this.state.action === 1 || this.state.action === 2) &&
      (agent === "" || agent === null)
    ) {
      message.error("Who do you want to send to?");
      has_error = true;
    }

    // Check if expiration date is missing for action 2 or 3
    if (
      (this.state.action === 2 || this.state.action === 3) &&
      (expiration_date === "" || expiration_date === null)
    ) {
      has_error = true;
      message.error("Expiration date is required.");
    }

    return !has_error;
  };

  // Data sending function
  sendData = () => {
    message.destroy();
    const { wizard, updateField, save } = this.props;
    const { agent, expiration_date, notes } = this.state;
    let user = Cookies.get("user_info") !== "undefined"
      ? JSON.parse(Cookies.get("user_info"))
      : {};

    this.setState({ loading: true });
    updateField("is_saved_for_later", 0);

    // Handle action-specific data updates
    if (this.state.action === 0) {
      updateField("status", "Renewal");
      updateField("is_renewal", 1);
      updateField("no_follow_up", 1);
    }

    if (this.state.action === 2) {
      F.log("agent else : ", this.state);
      if (this.state.onBoarding_agent === "Virtual Onboarder") {
        updateField("vonboard", 1);
        updateField("is_onboarded", 1);
        updateField("onboarder_id", user.id);
        updateField(
          "vo_sent_date",
          moment()
            .utc()
            .format("YYYY-MM-DD HH:mm:ss")
        );
        updateField(
          "expiration_date",
          moment(expiration_date).format("YYYY-MM-DD")
        );
      } else {
        updateField("onboarding_id", agent);
        updateField("onboarder_id", user.id);
        updateField("is_onboarded", 1);
        updateField("need_attention", 1);
        updateField("vo_sent_date", moment().utc().format("YYYY-MM-DD HH:mm:ss"));
        updateField("expiration_date", moment(expiration_date).format("YYYY-MM-DD"));
      }
    }

    if (this.state.action === 2) {
      // if (this.state.onBoarding_agent === "Virtual Onboarder") {
      updateField("vonboard", 1);
      updateField("is_onboarded", 1);
      updateField("onboarder_id", user.id);
      updateField("vo_sent_date", moment().utc().format("YYYY-MM-DD HH:mm:ss"));
      updateField("expiration_date", moment(expiration_date).format("YYYY-MM-DD"));
      // } else {
      //   updateField("onboarding_id", agent);
      //   updateField("onboarder_id", user.id);
      //   updateField("is_onboarded", 1);
      //   updateField("need_attention", 1);
      //   updateField("expiration_date", moment(expiration_date).format("YYYY-MM-DD"));
      // }
    }

    if (this.state.action === 3) {
      updateField("vonboard", 1);
      updateField("is_onboarded", 1);
      updateField("onboarder_id", user.id);
      updateField("vo_sent_date", moment().utc().format("YYYY-MM-DD HH:mm:ss"));
      updateField("expiration_date", moment(expiration_date).format("YYYY-MM-DD"));
    }

    // New add for `life_opportunities`
    updateField("life_opportunities", 1);

    // Save and post notes
    save((bfile) => {
      let notes_postfix = this.state.Checkbox_array;

      // Set default note's action
      let note_action = this.state.action === 1 ? "No Follow-Up" : "Send B File";

      axios.post("/api/bfile_notes", {
        bfile_id: bfile.id,
        note: notes + " ; " + this.props.wizard.sub_type_of_call,
        user_id: user.id,
        action: note_action,
        type_of_call: this.props.wizard.type_of_call,
        sub_type_of_call: this.props.wizard.sub_type_of_call,
      });

      if (this.state.action === 1) {
        axios.post("/api/need_attention", {
          bfile_id: bfile.id,
          sent_from: user.id,
          user_id: agent,
          note: notes,
        });
      }

      if (this.state.action === 3) {
        axios.get("/api/get_mb_association").then((res) => {
          if (res.data.assoc) {
            axios.put("/api/b_file/" + bfile.id, {
              vo_claim_date: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
              onboarder_id: res.data.assoc.id,
            });
          }
        });
      }
    });
  };

  //condition for submit
  Submit = () => {
    let action = 2
    this.setState({
      action: action
    });
    if (this.validateSendData()) {
      if (this.props.wizard.type_of_call_old === this.props.wizard.type_of_call) {
        this.sendData(); // Send data directly if no change in type_of_call
      } else {
        this.showConfirm(this.sendData.bind(this)); // Show confirmation first
      }
    }
  };
  // send = () => {
  //   message.destroy();
  //   const { wizard, updateField, save } = this.props;
  //   const { agent, expiration_date, notes } = this.state;
  //   let user = Cookies.get("user_info") !== "undefined"
  //     ? JSON.parse(Cookies.get("user_info"))
  //     : {}
  //   // F.log("ACTION", this.state.action);
  //   let has_error = false;
  //   if (notes.trim().length === 0) {
  //     message.error(F.translate(`Note is required.`));
  //   } else {
  //     if (
  //       (this.state.action === 1 || this.state.action === 2) &&
  //       (agent === "" || agent === null)
  //     ) {
  //       has_error = true;
  //       message.error("Who do you want to send to?");
  //       return false;
  //     }

  //     if (
  //       (this.state.action === 2 || this.state.action === 3) &&
  //       (expiration_date === "" || expiration_date === null)
  //     ) {
  //       has_error = true;
  //     }

  //     if (!has_error) {
  //       this.setState({ loading: true });
  //       updateField("is_saved_for_later", 0);

  //       if (this.state.action === 0) {
  //         updateField("status", "Renewal");
  //         //updateField("archive", 1);
  //         updateField("is_renewal", 1);
  //         updateField("no_follow_up", 1);
  //       }
  //       // F.log("<<<", this.state.action);
  //       if (this.state.action === 1) {
  //         updateField("financial_id", agent);
  //         updateField("need_attention", 1);
  //       }

  //       if (this.state.action === 2) {
  //         // F.log("agent else : ", this.state);
  //         if (this.state.onBoarding_agent === "Virtual Onboarder") {
  //           updateField("vonboard", 1);
  //           updateField("is_onboarded", 1);
  //           updateField("onboarder_id", user.id);
  //           updateField(
  //             "vo_sent_date",
  //             moment()
  //               .utc()
  //               .format("YYYY-MM-DD HH:mm:ss")
  //           );
  //           updateField(
  //             "expiration_date",
  //             moment(expiration_date).format("YYYY-MM-DD")
  //           );
  //         } else {
  //           updateField("onboarding_id", agent);
  //           updateField("onboarder_id", user.id);
  //           updateField("is_onboarded", 1);
  //           updateField("need_attention", 1);
  //           updateField(
  //             "expiration_date",
  //             moment(expiration_date).format("YYYY-MM-DD")
  //           );
  //         }
  //       }

  //       if (this.state.action === 3) {
  //         updateField("vonboard", 1);
  //         updateField("is_onboarded", 1);
  //         updateField("onboarder_id", user.id);
  //         updateField(
  //           "vo_sent_date",
  //           moment()
  //             .utc()
  //             .format("YYYY-MM-DD HH:mm:ss")
  //         );
  //         updateField(
  //           "expiration_date",
  //           moment(expiration_date).format("YYYY-MM-DD")
  //         );
  //       }

  //       // New add for `life_opportunities`
  //       updateField("life_opportunities", 1);

  //       // F.log("Checkbox_array", this.state.Checkbox_array);
  //       save((bfile) => {
  //         this.setState({ loading: false });
  //         let notes_postfix = this.state.Checkbox_array

  //         // Hide the following Notes API
  //         /*if (this.state.action === 1) {
  //           axios.post("/api/bfile_notes", {
  //             bfile_id: bfile.id,
  //             note: "No Follow-Up. " + notes_postfix,
  //             user_id: user.id,
  //           });
  //         } else {
  //           axios.post("/api/bfile_notes", {
  //             bfile_id: bfile.id,
  //             note: "Send B File. " + notes_postfix,
  //             user_id: user.id,
  //           });
  //         }*/

  //         // set default note's action
  //         let note_action = "Send B File";

  //         // change note's action if type `1`
  //         if (this.state.action === 1) {
  //           note_action = "No Follow-Up";
  //         }

  //         axios.post("/api/bfile_notes", {
  //           bfile_id: bfile.id,
  //           note: notes + " ; " + this.props.wizard.sub_type_of_call,
  //           user_id: user.id,
  //           action: note_action,
  //           type_of_call: this.props.wizard.type_of_call,
  //           sub_type_of_call: this.props.wizard.sub_type_of_call
  //           // follow_Up_Date:this.state.expiration_date
  //         });

  //         if (this.state.action === 1) {
  //           axios.post("/api/need_attention", {
  //             bfile_id: bfile.id,
  //             sent_from: user.id,
  //             user_id: agent,
  //             note: notes,
  //           });
  //           //EFS user no longer exist in our system
  //           // if(wizard.carrier !== "Country Financial"){
  //           // axios.post("/api/send_invite", {
  //           //   bfile_id: bfile.id,
  //           //   date_time: new Date().toUTCString(),
  //           //   location: "",
  //           //   type: "immediate-attention",
  //           //   user_id: user.id,
  //           // });
  //           // }
  //         }

  //         if (this.state.action === 3) {
  //           axios.get("/api/get_mb_association").then((res) => {
  //             if (res.data.assoc) {
  //               axios.put("/api/b_file/" + bfile.id, {
  //                 vo_claim_date: moment()
  //                   .utc()
  //                   .format("YYYY-MM-DD HH:mm:ss"),
  //                 onboarder_id: res.data.assoc.id,
  //               });
  //             }
  //           });
  //         }
  //       });
  //     } else {
  //       message.error("Please fill all required fields.");
  //     }
  //   }
  // };

  disabledDate(current) {
    return current && current < moment().startOf("day");
  }


  showConfirm = (sendCallback) => {
    confirm({
      title: (this.props.wizard.type_of_call_old !== this.props.wizard.type_of_call) && this.props.wizard.type_of_call_old ? `Currently B File is in ${TYPE_OF_CALL[`${this.props.wizard.type_of_call_old}`]} status. Do you want to move it to Opportunity?` : `Do you want to move this B file to Opportunity?`,
      // title: (this.props.wizard.type_of_call_old !== this.props.wizard.type_of_call) && this.props.wizard.type_of_call_old ? `Currently B-file is in Review status , Do you want to move status to FollowUp ?` : `Do you want to move status to FollowUp ?`,
      onOk() {
        return sendCallback()
      },
      onCancel() { },
      okButtonProps: {
        className: 'borderRadius-28 bg-164897'
      },
      cancelButtonProps: {
        className: 'borderRadius-28'
      }
    });
  }


  onChangeSubType = (value = "") => {
    this.props.updateField("sub_type_of_call", value.join() || "");
    this.props.updateField("sub_type_of_call_change", value.join() || "")
  }


  render() {
    const {
      loading,
      action,
      // financial_users,
      // onboarding_users,
      expiration_date,
      agent,

    } = this.state;
    // F.log("checkbox", this.state.Checkbox_array);
    // F.log("295", financial_users);
    const { onboarding_users, financial_users, user, updateField } = this.props;
    // F.log(this.state);
    // F.log(this.props);
    // onboarding_users.filter((on)=>)

    const agencyData = DataHandler.getTempHoldAgencyData();

    let title = "Send B File";
    //if (action === 1) title = "Send via Immediate Attention for Financial Review";
    // console.log("action",action);

    if (action === 1) title = "Send For Follow Up";
    if (action === 2) title = "Send For Follow Up";
    if (action === 3) title = "Send to Virtual Follow-Up";

    let sub_type_of_call_list = {}

    Object.keys(SUB_TYPE_OF_CALL).forEach(e => {
      sub_type_of_call_list[e.toLowerCase()] = SUB_TYPE_OF_CALL[e]
    })

    // let sub_type_of_call_list = {
    //   "followup":["Thankyou/Referral","Life insurance","Cross-sell","Retirement"],
    //   "prospect":["Requote","Win back"],
    //   "review":['']
    // }

    return (
      <div style={{ marginBottom: 20 }}>
        <Modal
          title={<Translate text={title} />}
          visible={this.props.showModal}
          footer={null}
          onCancel={() => {
            this.setState({ notes: "" }, () => {
              this.props.hideModal()
            })
          }}
          maskClosable={false}
        >
          <Spin indicator={antIcon} spinning={loading}>
            <div id="send_bfile_modal">
              <div className="formBox">
                {/* <div style={{marginBottom:20}}>
                            <Button onClick={() => this.setState({ action: null })}><Icon type="arrow-left" /> <Translate text={`Back`} /></Button>
                        </div> */}

                {/* <div style={{ marginBottom: 10 }}>
                  <label>
                    <Translate text={`Select Who to Follow-Up`} />
                  </label>
                  <Select
                    value={this.state.onBoarding_agent}
                    style={{ width: "100%" }}
                    onChange={(val) => {
                      if (
                        this.state.onBoarding_agent === "Send For Follow Up"
                      ) {
                        let action = 1;
                      }
                      let action = 2;

                      this.setState({
                        agent: val,
                        onBoarding_agent: val,
                        action,
                      });
                    }}
                  >
                    <Option value={null}>
                      <Translate text={`Select`} />
                      ...
                    </Option>
                    {onboarding_users.map((user) => {
                      if (user.id == 'Virtual Onboarder'
                        && ((this.props.wizard.agency &&
                          this.props.wizard.agency.vonboard !== null &&
                          this.props.wizard.agency.vonboard === 0) ||
                          (agencyData && agencyData.vonboard !== null && agencyData.vonboard) === 0))
                        return null;
                      else
                        return (
                          <Option key={user.id} value={user.id}>
                            {user.name}
                          </Option>
                        );
                    })}

                   
                  </Select>
                </div> */}

                <Row gutter={16}>
                  {/* <Col md={12} span={24}>
                  <div style={{ marginBottom: 10 }}>
                    <label>
                      <Translate text={`Type of Call`} />:
                    </label>
                    <Select
                      value={this.props.wizard.type_of_call && this.props.wizard.type_of_call.toLowerCase() === 'followup' && 'FollowUp'||this.props.wizard.type_of_call||""}
                      style={{ width: "100%" }}
                      onChange={(value) => {
                        updateField("type_of_call", value);
                        updateField("sub_type_of_call", "");
                        updateField("type_of_call_change",value)
                        updateField("sub_type_of_call_change","")
                      }}
                    >
                      <Option value={""}>
                        <Translate text={`Select`} />
                        ...
                      </Option>
                      {this.props.wizard.agency_info && this.props.wizard.agency_info.review && user.id !==2 && <Option value="Review">
                        <Translate text={`Review`} />
                      </Option>}
                      <Option value="FollowUp">
                        <Translate text={`Follow Up`} />
                      </Option>
                      <Option value="Prospect">
                        <Translate text={`Prospect`} />
                      </Option>
                    </Select>
                  </div>
                </Col> */}

                  <Col md={24} span={24}>
                    <div style={{ marginBottom: 10 }}>
                      <label>
                        <Translate text={`Sub Type of Call`} />:
                      </label>
                      <Checkbox.Group value={get_label_from_value(this.props.wizard.sub_type_of_call, 'value', this.props.wizard.type_of_call) && get_label_from_value(this.props.wizard.sub_type_of_call, 'value', this.props.wizard.type_of_call).split(",") || []}
                        onChange={(e) => this.onChangeSubType(e)}
                        style={{ display: 'flex', flexWrap: 'wrap' }}
                      >
                        {SUB_TYPE_OF_CALL['FollowUp'].map((option, i) => (
                          <Checkbox key={i} value={option.value} style={{ width: 180 }} disabled={option.disable}>
                            {option.label}
                          </Checkbox>))
                        }
                      </Checkbox.Group>



                      {/* <Radio.Group style={{width:'100%'}} value={this.props.wizard.sub_type_of_call_change} onChange={(e)=>this.onChangeSubType(e.target.value)}>
                    <Row gutter={12}>
                      {SUB_TYPE_OF_CALL[this.props.wizard.type_of_call].map((e,i)=>{
                        return(
                          <Col md={9} span={24}>
                          <Radio value={e}>{e}</Radio>
                          </Col>
                        )
                      })}
                    </Row>
                  </Radio.Group>  */}



                      {/* <Select
                      value={this.props.wizard.sub_type_of_call}
                      style={{ width: "100%" }}
                      onChange={(value) => {
                        updateField("sub_type_of_call", value);
                        updateField("sub_type_of_call_change",value)
                      }}
                    >
                      <Option value={""}>
                        <Translate text={`Select`} />
                        ...
                      </Option>
                      { this.props.wizard.type_of_call && sub_type_of_call_list[this.props.wizard.type_of_call.toLowerCase()] && sub_type_of_call_list[this.props.wizard.type_of_call.toLowerCase()].map(e=>{
                        return(
                      <Option value={e}>
                        <Translate text={e} />
                      </Option>
                        )
                      })}
                     </Select> */}
                    </div>
                  </Col>
                </Row>




                <div>
                  {/* <Checkbox.Group style={{ width: "1%", color: "blue" }}> */}
                  {/* <Row>
                    <Col span={8}>
                      <Radio value={1} defaultChecked disabled={true} onChange={(val)=>{val}}>
                        <Translate text={" Thank You & Referrals"} />
                      </Radio>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={8}>
                      <Radio value={2}>
                        <Translate text={" Life Insurance"} />
                      </Radio>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={8}>
                      <Radio value={3}>
                        <Translate text={" P&C"} />
                      </Radio>
                    </Col>
                  </Row> */}
                  {/* <Checkbox.Group
                    style={{
                      width: "100%",
                    }}
                    // onChange={this.messagecheck()}
                  >
                    <Row>
                      <Col span={8}>
                        <Checkbox defaultChecked disabled>
                          Thank You & Referrals
                        </Checkbox>
                      </Col>

                      <Col span={8}>
                        <Checkbox
                          value="B"
                          onChange={() => this.messageCheck("Life Insurance")}
                        >
                          Life Insurance
                        </Checkbox>
                      </Col>
                      <Col span={8}>
                        <Checkbox
                          value="C"
                          onChange={() => this.messageCheck("P&C")}
                        >
                          P&C
                        </Checkbox>
                      </Col>
                    </Row>
                  </Checkbox.Group> */}
                  {/* </Checkbox.Group> */}
                  {/* <Radio.Group name="radiogroup" defaultValue={1}>
                    <Row>
                      <Col span={8}>
                        <Radio value={1}>A</Radio>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <Radio value={2}>B</Radio>
                      </Col>
                    </Row>

                    <Radio value={3}>C</Radio>
                    <Radio value={4}>D</Radio>
                  </Radio.Group> */}
                </div>
                {/* {F.log("010", financial_users)} */}
                {this.state.onBoarding_agent !== "Virtual Onboarder" && (
                  <div style={{ marginBottom: 10 }}>
                    <label>
                      <Translate text={`Agent`} />
                    </label>
                    {/* {F.log("12", financial_users)} */}
                    <Select
                      placeholder="Select"
                      style={{ width: "100%" }}
                      value={agent === "Send For Follow Up" ? null : agent}
                      onChange={(val) => {
                        if (
                          this.state.onBoarding_agent === "Send For Follow Up"
                        ) {
                          let action = 1;
                        }
                        let action = 2;
                        // F.log("agent", agent);
                        // F.log("agent", financial_users);
                        for (let i = 0; i < financial_users.length; i++) {
                          if (
                            financial_users[i].id === val &&
                            financial_users[i].user_type === "EFS"
                          ) {
                            action = 1;
                            break;
                          }
                        }

                        this.setState({
                          agent: val,
                          action,
                          isAdditionalActions: true,
                        });
                      }}
                    >
                      <Option value={null}>
                        <Translate text={`Select`} />
                        ...
                      </Option>
                      {/* {F.log("22", financial_users)} */}
                      {financial_users.map((fu, i) => {
                        // F.log(financial_users);
                        return (
                          <Option key={i} value={fu.id}>
                            {fu.id == user.id ? (
                              <Translate text={`Me`} />
                            ) : (
                              fu.name
                            )}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                )}

                <div style={{ marginBottom: 10 }}>
                  <label>
                    <Translate text={`Date To Follow-Up With Customer`} />
                  </label>
                  <DatePicker
                    format="MM/DD/YYYY"
                    value={expiration_date}
                    disabledDate={this.disabledDate}
                    onChange={(val) => this.setState({ expiration_date: val })}
                  />
                </div>

                <div style={{ marginBottom: 10 }}>
                  {/* <label>
                    <Translate text={`Notes`} />
                  </label> */}
                  <span>
                    Notes{" "}
                    <span style={{ color: "red" }}>
                      (Please give specific details regarding your Follow-Up
                      request.)
                    </span>{" "}
                  </span>
                  <TextArea
                    rows={4}
                    onChange={(e) => this.setState({ notes: e.target.value })}
                    style={{ marginTop: 8 }}
                    value={this.state.notes}
                  // maxLength={264}
                  />
                </div>

                <div className="right-align">
                  <Button
                    disabled={
                      this.state.agent === "Send For Follow Up" ||
                      this.state.agent === null
                    }
                    type="primary"
                    className="borderRadius-28 bg-164897"
                    // onClick={() =>
                    //   (this.props.wizard.type_of_call_old === this.props.wizard.type_of_call) ?
                    //     this.send()
                    //     : this.showConfirm(this.send.bind(this))

                    // }
                    onClick={() => this.Submit()}
                  >
                    <Translate text={`Submit`} />
                  </Button>
                </div>
              </div>

              {/* <Row gutter={16}>
                            <Col md={12} span={24}>
                                <Tooltip placement="bottom" title={
                                    <div>
                                        <strong><Translate text={`Send For Follow Up`} /></strong><br/>
                                        <Translate text={`The next step in the B File process is to send this customer over to the Agency Owner or designated agent in charge of thanking the customer for his/her business, and introducing him/her to a life & retirement specialist.`} />
                                    </div>
                                }>
                                    <span className="ant-badge">
                                        <Button type="primary" className="actionbtn btn-blue" onClick={() => this.setState({ action: 2})}>
                                            <Translate text={`Send For Follow Up`} />
                                        </Button>

                                        <sup data-show="true" className="ant-scroll-number ant-badge-count ant-badge-multiple-words" title="Recommended" style={{left:62,right:'inherit'}}><Translate text={`Recommended`} /></sup>
                                    </span>
                                </Tooltip>
                            </Col>
                            {/* <Col md={12} span={24}>
                                <Tooltip placement="bottom" title={
                                    <div>
                                        <strong><Translate text={`Send to Virtual On-boarder`} /></strong>
                                    </div>
                                }>
                                    <span className="ant-badge">
                                        <Button type="primary" className="actionbtn btn-blue" onClick={() => this.setState({ action: 3})}>
                                            <Translate text={`Send to Virtual On-boarder`} />
                                        </Button>

                                        <sup data-show="true" className="ant-scroll-number ant-badge-count ant-badge-multiple-words" title="Recommended" style={{left:62,right:'inherit'}}><Translate text={`Recommended`} /></sup>
                                    </span>
                                </Tooltip>
                            </Col> */}
              {/* <Col md={12} span={24}>
                                <Tooltip placement="bottom" title={
                                    <div>
                                        <strong><Translate text={`Send via Immediate Attention for Financial Review`} /></strong><br/>
                                        <Translate text={`If the customer is in need of immediate assistance and wants to speak with someone regarding financial planning or life & retirement options, you can bypass the Welcome call and send the B File customer directly to the Financial Specialist.`} />
                                    </div>
                                }>
                                    <Button type="primary" className="actionbtn btn-gray" onClick={() => this.setState({ action: 1})}>
                                        <Translate text={`Send via Immediate Attention for Financial Review`} />
                                    </Button>
                                </Tooltip>
                            </Col> */}
              {/* <Col md={12} span={24}>
                                <Tooltip placement="bottom" title={
                                        <div>
                                            <strong><Translate text={`No Follow-Up`} /></strong><br/>
                                            <Translate text={`Using this function will bypass the B File process and automatically put this customer in a renewal status. This is only recommended if the customer is a long term customer and has all his/her opportunities with the agency already.`} />
                                        </div>
                                    }>
                                    <Button type="primary" className="actionbtn btn-gray" onClick={() => this.setState({ action: 0}, () => {  this.send() })}>
                                        <Translate text={`No Follow-Up`} />
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row> */}
            </div>
          </Spin>
        </Modal>
      </div>
    );
  }
}

export default DashModal;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/send-bfile-modal.js